<div class="external-links">
	@if (isLoading()) {
		<lb-loader></lb-loader>
	} @else if (error()) {
		<div class="error-message">{{ error() }}</div>
	} @else if (externalLinks().length > 0) {
		@for (link of externalLinks(); track link.key) {
			<a
				md-button
				class="external-link-button"
				[href]="link.url"
				target="_blank"
				rel="noopener noreferrer"
				[title]="mode() === 'compact' ? 'Open ' + link.displayName : link.displayName"
			>
				<img [src]="link.logoPath" [alt]="link.displayName" class="app-logo" />
				@if (mode() === 'labeled') {
					<span class="app-label">{{ link.displayName }}</span>
				}
			</a>
		}
	}
	@if (showEditExternalLinks()) {
		<button
			md-button
			class="integration-settings-button"
			(click)="openIntegrationDialog()"
			[title]="mode() === 'compact' ? 'Integration Settings' : 'Integration Settings'"
		>
			<md-icon icon="untitled-ui/general/settings-01" class="settings-icon"></md-icon>
			@if (mode() === 'labeled') {
				<span class="app-label">Settings</span>
			}
		</button>
	}
</div>
